import React from 'react';
import IconHelp from '@components/icons/IconHelp';
import useToggle from '@hooks/useToggle';
import Title from '@components/Title';
import Button from '@components/Button';
import Modal from '@components/Modal';
import { useLibSpace } from '@apis/queryHooks/useLibSpace';

function LibModalSpace() {
  const helpModal = useToggle(false);

  const { remainStorageText } = useLibSpace();

  return (
    <div className="border-b pt-20 pr-20 pb-20">
      <div className="flex items-center">
        <div>空间容量</div>
        <IconHelp
          scheme="light"
          className="ml-10"
          onClick={() => helpModal.on()}
        />
      </div>
      <div className="mt-5">{remainStorageText || <br />}</div>
      <Modal
        isOpen={helpModal.isOn}
        header={<Title>空间说明</Title>}
        footer={<Button onClick={() => helpModal.off()}>我知道了</Button>}
        hideCancel
        onRequestClose={() => helpModal.off()}
      >
        <div className="py-10">
          <div className="mb-20">
            空间容量是指用户在720yun平台上传存储的媒体文件（包括全景图、全景视频、高清矩阵、普通图片、音频、视频等）所占据的空间大小，每个文件的大小以上传时的原始文件大小计算为准。
          </div>
          <div className="mb-20">
            考虑到平台存储成本，每个用户有一定容量上限的免费空间，超过该上限后，用户可通过删除旧的媒体文件、升级个人专业版/企业版、或单独购买空间扩容服务来扩容空间继续使用。
          </div>
          <div>说明：2020年4月25日之前上传的媒体文件不计入您的空间容量。</div>
        </div>
      </Modal>
    </div>
  );
}

export default LibModalSpace;
